export const SECTION_FOUR_CREATE_ORG_REQUIRED_HINT =
  "Для создания записи необходимо, чтобы в титульный лист была добавлена ваша организация";
